export default __webpack_public_path__ + "static/media/logo_homepage.82bb6bcf.png";